import React from 'react'
import { useState, useEffect } from "react";
import LoaderGif from "../assets/images/home/loader.gif"

const Loader = () => {
    const [loading, setLoading] = useState(true);
    const [hidden, setHidden] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setHidden(true);
            setTimeout(() => setLoading(false), 500);
        }, 500);

        return () => clearTimeout(timer);
    }, []);

    if (!loading) return null;

    return (
        // Preloader
        <div className={`page-loader ${hidden ? "hidden" : ""}`}>
            <img src={LoaderGif} alt="Loading..." />
        </div>
    )
}

export default Loader